import { ReactNode } from "react";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";

export function IsStripeCustomer(props: { children?: ReactNode }) {
  const { business } = useSellarCurrentBusiness();

  if (business?.Supplier?.stripeCustomerId) return <>{props.children}</>;
  return null;
}
